//moved to appController, having an issue with gulp packager seems to be leaving this file out
let Config = {
    appName: "Minesweeper"
    , version: "3.2.1"
    , serverUrl_Default: "wss://minesjd.com"
    , serverUrls: {"USA":"wss://minesjd.com","EU":"wss://eu.minesjd.com"}
    , serverUrl_Discord: (location.protocol === 'http:')? `ws://${location.host}`:`wss://${location.host}/.proxy/`
    , fullVersion: false
    , showErrors: false
    , showAppLinks: true
    , debugMode: false
    , facebookAddId: 158327870889130
    , showMoreGames: true
    , showWebContent: null
};
export default Config ;

